/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientWorkspaceUserDto } from '../../models/client-workspace-user-dto';
import { CreateClientWorkspaceUserDto } from '../../models/create-client-workspace-user-dto';

export interface ClientWorkspaceUserControllerCreateMember$Params {

/**
 * 고객사 ID
 */
  id: string;
      body: CreateClientWorkspaceUserDto
}

export function clientWorkspaceUserControllerCreateMember(http: HttpClient, rootUrl: string, params: ClientWorkspaceUserControllerCreateMember$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceUserDto>> {
  const rb = new RequestBuilder(rootUrl, clientWorkspaceUserControllerCreateMember.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientWorkspaceUserDto>;
    })
  );
}

clientWorkspaceUserControllerCreateMember.PATH = '/api/clientWorkspaceUser/{id}/users';
